import React, { useEffect, useMemo, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { useSelector, useDispatch } from "react-redux";
import { tokens } from "../../../theme";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  Box,
} from "@mui/material";
import {
  deleteTypeVariation,
  getTypeVariations,
  getTypeVariationError,
  getTypeVariationStatus,
  selectAllTypeVariations,
  updateStatus,
  getTypeVariationSuccess,
} from "../../../features/typeVariationSlice";
import Loading from "../../../components/loading";
import Error from "../../../components/Error";
import { toast } from "react-toastify";
import AppBarSearch from "../../../global/appBarSearch";
import NoDataTable from "../../../components/noDataTable";
import { useNavigate } from "react-router-dom";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import {
  ellipsisText,
} from "../../../global/functions/textFormat";
import ParagraphHighliter from "../../../components/paragraphHighliter";
import { ResponsiveProvider } from "../../../hooks/uiHook";
import AlertDialog from "../../../components/alertDialog";
import ShowMultiItems from "../../../components/showMultiItems";
import { useTranslation } from "react-i18next";
import TableActions from "../../../components/tableActions";

const TypeVariantion = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { restaurantId } = useRestaurant();
  const [localTypeVariations, setLocalTypeVariations] = useState([]);
  const [open, setOpen] = useState(false);
  const [cardId, setCardId] = useState(null);
  const [search, setSearch] = useState("");
  const status = useSelector(getTypeVariationStatus);
  const error = useSelector(getTypeVariationError);
  const variations = useSelector(selectAllTypeVariations);
  const success = useSelector(getTypeVariationSuccess);

  useEffect(() => {
    dispatch(getTypeVariations(restaurantId));
  }, [dispatch, restaurantId]);

  useEffect(() => {
    if (status === "fetchTypeVariation") setLocalTypeVariations(variations);
  }, [variations, status]);

  const filteredTypeVariationsMemo = useMemo(() => {
    return (localTypeVariations || []).filter((typeVariation) => {
      const searchTerm = search.toLowerCase();
      return (
        (typeVariation.name || "").toLowerCase().includes(searchTerm) ||
        (typeVariation.label || "").toLowerCase().includes(searchTerm) ||
        (typeVariation.description || "").toLowerCase().includes(searchTerm)
      );
    });
  }, [localTypeVariations, search]);


  useEffect(() => {
    if (status === "deleteSuccess") {
      toast.success(success);
      setLocalTypeVariations((prev) =>
        prev.filter((item) => item._id !== cardId)
      );
      dispatch(updateStatus());
    } else if (status === "deleteError") {
      toast.error(error);
    }
  }, [cardId, dispatch, error, status, success]);

  const handleSubmit = (event) => {
    event.preventDefault();
    navigate("add");
  };

  const handleModify = (data) => {
    navigate("modify", { state: { typeVariation: data } });
  };

  const handleClickOpen = (cardId) => {
    setOpen(true);
    setCardId(cardId);
  };

  return (
    <div className="main-application">
      <CssBaseline />
      <ResponsiveProvider maxWidth={900}>
      <AppBarSearch
        searchText={t("search.byNameLabelDescription")}
        handleSubmit={handleSubmit}
        handleSearch={(e) => setSearch(e.target.value)}
        title={t("pages.myTypeVariations")}
        buttonTitle={t("actions.addVariation")}
      />
      </ResponsiveProvider>
      <main>
        <Box sx={{ my: 2 }}>
          <TableContainer>
            <Table
              sx={{
                backgroundColor: colors.primary[400],
              }}
            >
              <TableHead
                sx={{
                  backgroundColor: colors.primary[700],
                }}
              >
                <TableRow>
                  <TableCell>{t("table.name")}</TableCell>
                  <TableCell>{t("table.label")}</TableCell>
                  <TableCell>{t("table.description")}</TableCell>
                  <TableCell>{t("table.variations")}</TableCell>
                  <TableCell align="right">{t("table.actions")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {status === "loadingFetchTypeVariation" ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      <Loading size={8} />
                    </TableCell>
                  </TableRow>
                ) : status === "fetchError" ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      <Error>{error}</Error>
                    </TableCell>
                  </TableRow>
                ) : filteredTypeVariationsMemo &&
                  filteredTypeVariationsMemo.length > 0 ? (
                  filteredTypeVariationsMemo.map((card) => (
                    <TableRow key={card._id}>
                      <TableCell>
                        <ParagraphHighliter
                          title={card.name}
                          search={search}
                        />
                      </TableCell>
                      <TableCell>
                        <ParagraphHighliter
                          title={card.label}
                          search={search}
                        />
                      </TableCell>
                      <TableCell>
                        <ParagraphHighliter
                          title={ellipsisText(card.description)}
                          search={search}
                        />
                      </TableCell>
                      <TableCell>
                        <ShowMultiItems items={card.variations} useStyledTypography={false} />
                      </TableCell>
                      <TableCell align="right">
                        <TableActions
                          actions={[
                            {
                              type: "delete",
                              color: "error",
                              label: t("common.delete"),
                              onClick: () => handleClickOpen(card._id),
                            },
                            {
                              type: "edit",
                              color: "warning",
                              label: t("common.edit"),
                              onClick: () => handleModify(card),
                            },
                          ]}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <NoDataTable cols={5} />
                )}
                <AlertDialog
                  handleClose={() => setOpen(false)}
                  open={open}
                  name={"type de variation"}
                  cardId={cardId}
                  deleteData={() =>
                    dispatch(
                      deleteTypeVariation({
                        typeVariationId: cardId,
                        restaurantId,
                      })
                    )
                  }
                />
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </main>
    </div>
  );
};

export default TypeVariantion;